import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

const Card = props =>{
    return <TouchableOpacity {...props} style={{...Styles.card, ...props.style}} >{props.children}</TouchableOpacity>
};

let Styles = {
    card: {
        padding: 20,
        margin:10,
        backgroundColor: '#ffffff',
        shadowColor: 'black',
        shadowOffset: {width: 0, height:2},
        shadowRadius: 6,
        shadowOpacity: 0.26,
        elevation: 10,
        borderRadius: 7,
    },
};
// const styles = StyleSheet.create({
//     card: {
//         padding: 20,
//         margin:10,
//         backgroundColor: '#ffffff',
//         shadowColor: 'black',
//         shadowOffset: {width: 0, height:2},
//         shadowRadius: 6,
//         shadowOpacity: 0.26,
//         elevation: 10,
//         borderRadius: 15,
//     },
// });

export default Card;